module.exports = __webpack_public_path__ + "img/partner_puppynrw.12bc0d7d.png";